/* global lozad */ // tUrl等のグローバル変数を宣言する

import './_smoothScroll.js' // スムーズスクロール
// import Swiper from 'swiper' // Swiper
// import PerfectScrollbar from 'perfect-scrollbar' // 独自スクロールバー
// position:styckyのポリフィル
// Stickyfill.add(document.querySelectorAll('.sticky'))

jQuery(function($) {
  // このIDを基準としたアコーディオン
  let accBtn = 'sp-menu'
  $('#' + accBtn + '-open,#' + accBtn + '-close').on('click', function() {
    $('#' + accBtn + ',#' + accBtn + '-open,#' + accBtn + '-close').toggleClass(
      'active'
    )
    $('body').toggleClass('lock')
  })

  // アコーディオンメニュー
  $('.acc-btn').on('click', function() {
    $('.acc-text', this).toggleClass('active')
    $('.img', this).toggleClass('active')
    $('.acc-body', this).slideToggle(1000)
  })

  // 画面に交差した要素をactive
  lozad('.lozad,.chain', {
    rootMargin: '5%',
    loaded: function(el) {
      el.classList.add('active')
    }
  }).observe()

  // 画像の右クリック・ドラッグ禁止
  $('img').on('contextmenu selectstart mousedown', function() {
    return false
  })

  function trunk8() {
    $('.js-t8.line2').trunk8({
      // 指定要素に行数制限をかける
      lines: 2,
      fill: '...'
    })
    $('.js-t8.line3').trunk8({
      // 指定要素に行数制限をかける
      lines: 3,
      fill: '...'
    })
  }
  trunk8()
  $(window).on('load resize ', function() {
    trunk8()
  })

  // IEでのスクロール時背景カクつき対応
  // IEの設定のスムーズスクロールを無効に
  if (
    navigator.userAgent.match(/MSIE 10/i) ||
    navigator.userAgent.match(/Trident\/7\./) ||
    navigator.userAgent.match(/Edge\/12\./)
  ) {
    $('body').on('mousewheel', function() {
      event.preventDefault()
      var wd = event.wheelDelta
      var csp = window.pageYOffset
      window.scrollTo(0, csp - wd)
    })
  }
})
